import EmployeeDataGrid from "./EmployeeDataGrid";

export default EmployeeDataGrid;
